import {produce} from 'immer';

import {LastSyncedUpstreamValue} from 'notebook/structured-tables/StructuredTableConstants';
import ProcessOutputStructuredTableAdapter, {
  ProcessOutputStructuredTable,
} from 'processes/tables/ProcessOutputStructuredTableAdapter';

import {ProcessOutputGraphQL as ProcessOutput} from '../../../graphql-fragments/processes/__generated/ProcessOutputGraphQL';

/**
 * This function should only be used from the workspace tab. Tables in entries
 * are updated normally by the notebook code.
 */
export default function updateOutputTable(
  table: ProcessOutputStructuredTable,
  outputs: Array<ProcessOutput>,
  lastSyncedUpstreamValues?: Array<Array<LastSyncedUpstreamValue>>,
  rowsAreFinalized: boolean = false
): ProcessOutputStructuredTable {
  const adapter = ProcessOutputStructuredTableAdapter.getAdapter();

  return produce(table, (draftTable) => {
    draftTable.rows = outputs.map((output, outputIndex) => ({
      ...adapter.getBlankRow(table.metadata, outputIndex, table.columns),
      ...ProcessOutputStructuredTableAdapter.makeRowFromOutput(output, table.columns),
      isFinalized: rowsAreFinalized,
      metadata: adapter.getBlankRowMetadata(table.metadata),
      ...(lastSyncedUpstreamValues ? {lastSyncedUpstreamValues: lastSyncedUpstreamValues[outputIndex]} : {}),
    }));
  });
}
